module.exports = __webpack_public_path__ + "img/Rectangle 7542.dd692b7e.png";